import { useEffect, useMemo, useState } from 'react';
import { Card, Col, Nav, NavItem, NavLink, Row } from 'reactstrap';
import { useLocation, useHistory } from 'react-router-dom';
import { withRouter } from "react-router-dom";
import { withNamespaces } from "react-i18next";
import { isFeatureEnabledForActiveModule } from 'src/helpers/module_helper';

const Tabs = ({
    t
}) => {
    const [activeTab, setActiveTab] = useState("");
    const history = useHistory();
    const location = useLocation();

    const isActiveTab = (currentTab, tab) => currentTab === tab;

    const tabsLinks = useMemo(() => {
        let links = [];

        if(isFeatureEnabledForActiveModule('eudr_activation')) {
            links.push({
                key: "geocledian",
                title: "GeoCledian"
            });
        }

        if(isFeatureEnabledForActiveModule('kyb_activation')) {
            links = [
                ...links,
                {
                    key: "companyinfo",
                    title: "Company Info"
                },
                {
                    key: "dnb",
                    title: "Dun & Bradstreet"
                }
            ]
        }

        return links;
    }, []);

    useEffect(() => {
        if(!tabsLinks.length) return;
        
        const tabKey = (new URLSearchParams(location.search)).get('tab');
        const tab = tabsLinks.find((tab) => tab.key === tabKey);

        if (!tab) {
            history.push({
                search: '?tab=' + tabsLinks[0].key
            });
        }
        else {
            setActiveTab(tab.key);
        }
    }, [
        location.search,
        tabsLinks,
        history
    ]);

    return (
        <Row>
            <Col sm="12" md="12" lg="8" xl="6">
                <Card>
                    <Nav tabs className='nav-tabs-custom nav-justified'>
                        {
                            tabsLinks.map((link) => {
                                return (
                                    <NavItem
                                        className={isActiveTab(activeTab, link.key) ? 'active' : ''}
                                        key={link.key}
                                    >
                                        <NavLink
                                            className={isActiveTab(activeTab, link.key) ? 'active' : ''}
                                            onClick={() => history.push({
                                                search: '?tab=' + link.key
                                            })}
                                        >
                                            {link.title}
                                        </NavLink>
                                    </NavItem>
                                )
                            })
                        }
                    </Nav>
                </Card>
            </Col>
        </Row>
    );
};

export default withNamespaces()(
    withRouter(Tabs)
);
